import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Link, useLocation, useNavigate } from "react-router-dom"; // Import Link from react-router-dom
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ResponsiveHeader from "./ResponsiveHeader";
import { Buttons, TypographyText } from "../Reuse/Reuse";
import logo from '../Assets/WhatsApp Image 2025-01-01 at 12.53.29_bab23465.jpg'

const Headers = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("lg"));
  // console.log(matches, "matches");
  
  const location = useLocation(); // Get the current location

  const [navactive, setNavactive] = useState("#");


  const handleScrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <AppBar
        sx={{
          backgroundColor: "white",

          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          {matches ? (
            <>
          <img src={logo}
          width="100px" height="70px"/>
              <Box>
  
                {navItems.map((item, index) => (
                  <Button
                    key={index}
                    sx={{ textTransform: "capitalize" ,color:'#2F6C6D'}}
                    onClick={() =>
                      location.pathname === "/contact"
                        ? (window.location.href = "/")
                        : handleScrollToSection(item.sectionId)
                    }
                  >
                    {item.label}
                  </Button>
            
                ))}
              </Box>
            </>
          ) : (
            <>
             <img src={logo}
          width="80px"/>
              <ResponsiveHeader />
            </>
          )}
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Headers;

export const navItems = [
  { label: "Home", sectionId: "home" },
  { label: "Why Us", sectionId: "whyus" },
  { label: "Vision & Mission", sectionId: "vissionandmission" },
  { label: "Our Services", sectionId: "ourservices" },
  { label: "Leadership", sectionId: "leadership" },
   { label: "Contact", sectionId: "contactme" },
];
